import Service from "./BaseService";
import { iCalculatePriceResponseData } from "./estimation/EstimationService";

interface iEstimationUser {
  mobile: string;
  registerNumber: string;
  firstName: string;
  lastName: string;
  email: string | null;
  aisysId: number;
  insuranceAisysID: number;
}

interface iEstimationVehicle {
  plateNumber: string;
}

interface iEstimationPayload {
  name: string;
  data: (iCalculatePriceResponseData & { cdn_path: string | null })[];
  user: iEstimationUser;
  vehicle: iEstimationVehicle;
  cdn_path: string | null;
  zuragu_source: string;
  price: number;
  state: string;
}

const save = (payload: iEstimationPayload) =>
  Service.create(`/estimation`, payload, { nonLoading: true });

const OdooEstimationService = {
  save,
};

export default OdooEstimationService;
